import React from 'react';
import { useTranslation } from 'react-i18next';

const FormLayout = ({ title, children, onSubmit, onCancel, hasCancelButton = true , hasSubmitButton=true, submitLabel}) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="row">
        <div className="col-lg-12 mb-lg-0 mb-4">
          <div className="card rounded-0 borderLine">
            <div className="card-header pb-0 rounded-0 bg-brand-primary cardHeaderBackground">
              <p className="crudTitle">{title}</p>
            </div>
            <div className="card-body p-3">
              <div className="row">
                <div className="container">
                  <div className="row">
                    <form onSubmit={onSubmit}>
                      <div className="row justify-content-start">
                        {children}
                        <div className="col-lg-12">
                          <div className="d-flex justify-content-end form-group mt-3">
                            {hasCancelButton && <button
                              type="button"
                              onClick={onCancel}
                              className="btn btn-md btn-secondary rounded-0 me-3"
                            >
                              {t("cancel")}
                            </button>}

                            {hasSubmitButton && 
                            <button
                              type="submit"
                              // className="btn btn-md btn-primary rounded-0"
                              className="btn btn-md btn-danger rounded-0"
                            >
                               {submitLabel || t("save")}
                            </button>
                            }
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormLayout;
